<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<!--单行文本，多行文本，超链接，自增编码-->
<template>
  <div class="text-edit-wrapper" :style="contentStyle">
    <template v-if="getFieldItem.fieldKey === 'qccId'">
      <jw-tag size="small" :color="getFieldItem.fieldValue ? 'green' : 'pink'">{{ getFieldItem.fieldValue ? $t('是') : $t('否') }}</jw-tag>
    </template>
    <template v-else>
      <template v-if="showDefaultCmp">
        <!-- 展示 -->
        <template v-if="!showEditContent">
          <template v-if="getFieldItem?.fieldValue">
            <span class="link-text" v-if="getFieldItem?.fieldType == 11" @click.stop="handleLinkClick">{{ getFieldItem.fieldValue }}</span>
            <span v-else>{{ getFieldItem.fieldValue }}</span>
          </template>
        </template>
        <!-- 编辑 -->
        <template v-else>
          <div :class="['link-wrap', getFieldItem?.fieldType == 11 ? 'link-text' : '']" :contenteditable="showEditContent" data-placeholder="请输入" ref="linkWrapRef" @keydown="handleKeydown">
            <template v-if="getFieldItem?.fieldValue">
              <span v-if="getFieldItem?.fieldType == 11">{{ getFieldItem.fieldValue }}</span>
              <span v-else>{{ getFieldItem.fieldValue }}</span>
            </template>
          </div>
        </template>
      </template>
      <template v-else>
        <template v-if="clickType == 1 && getFieldItem.sourceType == 2"
        ><span class="detail-empty-text">{{ getFieldItem?.showEmptyType ? getFieldItem?.showEmptyType : '' }}</span></template
        >
      </template>
    </template>
  </div>
</template>
<script setup>
import { onUnmounted } from 'vue';
import { ref, computed, watchEffect, nextTick } from 'vue';
// import { Message } from '@arco-design/web-vue';
// import { tools } from '@/utils/tools.js';
import { Message } from '@arco-design/web-vue';

const emits = defineEmits(['cb']);
const props = defineProps({
  params: {
    //字段数据
    type: Object,
    required: true,
    default: () => {
      return {};
    }
  },
  clickType: {
    type: String || Number,
    default: 0
  }
});
const getFieldItem = ref(props.params);
const linkWrapRef = ref(null);

// 在 script setup 中添加
const setCaretToEnd = () => {
  nextTick(() => {
    if (linkWrapRef.value) {
      const range = document.createRange();
      const sel = window.getSelection();
      range.selectNodeContents(linkWrapRef.value);
      range.collapse(false); // false 表示collapse到末尾
      sel.removeAllRanges();
      sel.addRange(range);
    }
  });
};

// 处理键盘事件
const handleKeydown = (event) => {
  // 如果按下Enter键但没有按Shift键，则触发保存
  if (event.key === 'Enter' && !event.shiftKey && props.params?.fieldType == 0) {
    event.preventDefault(); // 阻止默认的换行行为
    editSave();
  }
  // 如果按下Shift+Enter，则允许默认的换行行为（不做任何处理）
};

const stopWatchFieldItem = watchEffect(() => {
  getFieldItem.value = props.params;
});

const showDefaultCmp = computed(() => {
  // 编辑状态 、、 列表 、、有值
  return props.clickType == 2 || getFieldItem.value?.fieldValue;
});

const showEditContent = computed(() => {
  // 引用字段
  return props.clickType === 2 && props.params.col.fieldType !== 21 && props.params.editable;
});
const contentStyle = computed(() => {
  const setMaxHeight = getFieldItem.value.sourceType == 1 ? (showEditContent.value ? '388px' : '134px') : '280px';
  return {
    maxHeight: setMaxHeight
  };
});

// 失去焦点
const editSave = async () => {
  let cbValue = linkWrapRef.value?.textContent.trim();
  if (cbValue === '\n') cbValue = '';
  const cbParams = {
    fieldValue: cbValue
  };
  emits('cb', cbParams);
};

//点击跳转
const handleLinkClick = () => {
  console.log('点击链接33', getFieldItem.value.fieldValue, linkWrapRef.value, linkWrapRef.value?.innerText);
  if (props.clickType == 1) {
    try {
      window.open(getFieldItem.value.fieldValue, '_blank');
    } catch (error) {
      Message.warning('无效链接');
      console.log('无效链接:', error);
    }
  }
};

const stopWatchFocus = watchEffect(() => {
  if (props.clickType == 2) {
    nextTick(() => {
      linkWrapRef.value?.focus();
    });
  }
});

// 监听编辑状态变化
watchEffect(() => {
  if (showEditContent.value) {
    setCaretToEnd();
  }
});

onUnmounted(() => {
  // 卸载时停止监听
  stopWatchFocus();
  stopWatchFieldItem();
});

defineExpose({ editSave });
</script>
<style scoped lang="less">
@import './index.less';
</style>
